import React, { Component } from 'react';
import _, { isEmpty, get, cloneDeep } from 'lodash';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { PERMISSION } from '../../../../constants/permission';
import { checkTablePermission, checkAddPermission, checkPermission } from '../../../../utils/route-auth';

import Table from '../../../../components/CustomTable';
import ModalConfirmation from '../../../../components/ModalConfirmation';
import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import routes from '../../../../routes';
import moment from 'moment';

import {
    options,
    ageBidControlTable,
    ageBlacklistingTable,
    audienceBidControlTable,
    budgetAllocationTable,
    creativeBlacklistingTable,
    deviceBidControlTable,
    deviceBlacklistingTable,
    domainBlacklistingTable,
    genderBidControlTable,
    genderBlacklistingTable,
    geoBidControlTable,
    geoBlacklistingTable,
    keyWordBlacklistingTable,
    placementBlacklistingTable,
    targetCpaTable,
    targetCpcTable,
    targetCpmTable,
    targetRoasTable,
    bidSubtypeBidControlTable
} from './constant';

import {
    getOptimizerListAction,
    getOptimizerListRecommendationAction,
    getPaymentRelatedAccessAction,
    getRecoTypeSubTypeAction,
    thirdPartyExecuteAction,
    updateStatusAcceptRejectOptimizerAction
} from '../../../../actions';
import Spinner from '../../../../components/Spinner';
import SuccessCheckMark from '../../../../components/SuccessCheckMark';
import Reject from '../../../../assets/images/modalIcon/reject.png';
import Graph from '../../../../assets/images/modalIcon/graph.png';
import { getDateFromUtcToSpecificZone, getTenantTimeZone, isApiCallSuccess, isPlatformManager, isTenantAgency, isTenantDemoAdvertiser } from '../../../../selectors';
import { message } from 'antd';
import { bidControl, blacklistWhitlelisting, budgetOptimisation, generativeAI } from '../../../../constants/demo/optimizerData';
import { infoMessages } from '../../../../constants/demo/constant';
const Card = asyncRoute(() => import('../../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../../components/BreadCrumb'));
const Modal = asyncRoute(() => import('../../../../components/Modal'));


class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            IsAgency: JSON.parse(sessionStorage.getItem('IsAgency')),
            advertiserListData: [],
            confirmationOpen: false,
            confirmationInfo: '',
            currentTable: 1,
            currentTableName: 'Recommendation',
            currentRecommendationData: [],
            showSpinner: true,
            optimizerAcessDetails: {},
            isSemiSuspendedOrNot: 1,
            showSuspendDiv: false,
            isPlatformManager: '',
            acceptModal: false,
            rejectModal: false,
            viewRecommendModal: false,
            selectedRecommendation: null,
            keywordRecommendationData: [],
            creativeRecommendationsData: []


        };
    }

    // if tenant type is Demo advertiser
    isDemoAdvertiser = isTenantDemoAdvertiser(this.props.tenantId);

    async componentWillMount() {

        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
        const { history, getPaymentRelatedAccessAction, tenantId, userId, authToken } = this.props;
        if (isEmpty(isAuthenticated)) {
            history.push(routes.preSignIn);
        }


        // ****************optimizer Access Payment subscription realted Code starts here**********************************
        const dataLocal = JSON.parse(localStorage.getItem("PreSignInData"))
        let Isplat = dataLocal.responseList[0].tenantType
        this.setState({ isPlatformManager: Isplat })

        // if (Isplat == "Platform Manager") {
        //     this.setState({ showSpinner: false })
        // } else {
        //     await this.getListData();
        //     this.setState({ showSpinner: false })
        // }
        await this.getListData();
        this.setState({ showSpinner: false })

        // ****************optimizer Access Payment subscription realted Code End here*********************************

    }

    optimizerDataBasedOnTotalSection = (type) => {
        const combinedObjectOfData = { '1': bidControl.responseList, '2': blacklistWhitlelisting.responseList, '3': budgetOptimisation.responseList, '4': generativeAI.responseList }
        return combinedObjectOfData[type];
    }

    optimizerDataBasedOnSubSection = _.memoize((type, subtype) => {
        const combinedObjectOfData = {
            '4': { '8': generativeAI.responseList },
            '2': {
                '3': this.optimizedNestedDataFetch({ ...blacklistWhitlelisting.responseList }, "blackListing", "creatives"),
                '8': this.optimizedNestedDataFetch({ ...blacklistWhitlelisting.responseList }, "blackListing", "keyword"),
                '5': this.optimizedNestedDataFetch({ ...blacklistWhitlelisting.responseList }, "blackListing", "domain"),
                '4': this.optimizedNestedDataFetch({ ...blacklistWhitlelisting.responseList }, "blackListing", "device"),
                '6': this.optimizedNestedDataFetch({ ...blacklistWhitlelisting.responseList }, "blackListing", "gender"),
                '0': this.optimizedNestedDataFetch({ ...blacklistWhitlelisting.responseList }, "blackListing", "age")
            },
            '3': {
                '2': this.optimizedNestedDataFetch({ ...budgetOptimisation.responseList }, "budgetOptimisation", "budgetAllocation")
            },
            '1': {
                '7': this.optimizedNestedDataFetch({ ...bidControl.responseList }, "bidControl", "geo"),
                '4': this.optimizedNestedDataFetch({ ...bidControl.responseList }, "bidControl", "device"),
                '0': this.optimizedNestedDataFetch({ ...bidControl.responseList }, "bidControl", "age")
            }
        };
        return combinedObjectOfData[type][subtype];
    })

    optimizedNestedDataFetch(response, parent, target) {
        response[parent] = Object.fromEntries(Object.entries(response[parent]).filter(item => item[0] === target))
        return response;
    }

    getListData = async () => {
        try {
            const { tenantId, authToken, userId, getRecoTypeSubTypeAction, location } = this.props;
            const optimizerTypes = location.state;

            if (this.isDemoAdvertiser) {
                let dataToSet = {};
                if (optimizerTypes.variation === "subType") {
                    dataToSet = this.optimizerDataBasedOnSubSection(optimizerTypes.type, optimizerTypes.subType[0])
                }
                else dataToSet = this.optimizerDataBasedOnTotalSection(optimizerTypes.type)

                this.setState({
                    recommendationData: dataToSet
                })
                return;
            }
            let payload = {
                type: optimizerTypes.type,
                subType: optimizerTypes.subType,
            };


            // Check if the user is an agency and if the advertiserId is present in sessionStorage
            if (isTenantAgency(tenantId)) {
                const advertiserData = JSON.parse(sessionStorage.getItem('advertiserData'));
                const advertiserId = advertiserData && advertiserData.advertiserId;
                if (advertiserId) {
                    payload.advId = advertiserId;
                }
            }

            const {
                responseCode: { status = "" },
                responseList,
            } = await getRecoTypeSubTypeAction({ tenantId, authToken, userId, payload });

            if (isApiCallSuccess(status)) {
                console.log("responseList", responseList);


                this.setState({
                    recommendationData: responseList
                })

                // You can do further processing or set state here if needed
            } else {
                this.setState({ showSpinner: false });
            }
        } catch (err) {
            // Handle errors
            console.error(err);
            this.setState({ showSpinner: false });
        }
    }

    handleRecommedationAction = (row, action) => {
        const { match, history } = this.props;
        if (action.type === 'view') {
            this.setState({ viewRecommendModal: true, selectedRecommendation: row }, () => {
                if (this.isDemoAdvertiser) return;

                this.handleRowDetail()
            });
        }
        else if (action.type == 'accept') {
            this.setState({ selectedRecommendation: row }, () => {
                this.handleActionOverRecommedation(1);
            });

        }
        else if (action.type == 'reject') {
            this.setState({ selectedRecommendation: row }, () => {
                this.handleActionOverRecommedation(2);
            });
        }
    }

    handleRowDetail = async () => {
        try {
            const { tenantId, authToken, userId, getRecoTypeSubTypeAction, location } = this.props;
            const { selectedRecommendation } = this.state;

            const optimizerTypes = location.state;
            console.log('optimizerTypes:', optimizerTypes);

            let payload = {
                type: optimizerTypes.type,
                subType: [parseInt(selectedRecommendation.subTypeId)],
                // advId : IN CASE OF AGENCY
            };

            // Check if the user is an agency and if the advertiserId is present in sessionStorage
            if (isTenantAgency(tenantId)) {
                const advertiserData = JSON.parse(sessionStorage.getItem('advertiserData'));
                const advertiserId = advertiserData && advertiserData.advertiserId;
                if (advertiserId) {
                    payload.advId = advertiserId;
                }
            }

            let params = {
                id: selectedRecommendation.id
            }

            const {
                responseCode: { status = "" },
                responseList,
            } = await getRecoTypeSubTypeAction({ tenantId, authToken, userId, payload, params });

            if (isApiCallSuccess(status)) {
                // debugger;
                console.log("responseList", responseList);

                // debugger;
                this.setState({
                    rowData: responseList[0]
                    // As Response is an array > with 0th index having Type and inside that SubType arrays are present
                })

                // You can do further processing or set state here if needed
            } else {
                this.setState({ showSpinner: false });
            }
        } catch (err) {
            // Handle errors
            console.error(err);
            this.setState({ showSpinner: false });
        }
    }

    // Helper function to check if a string is a valid URL
    isValidUrl = (string) => {
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    }

    handleActionOverRecommedation = async (type) => {
        try {
            if (this.isDemoAdvertiser) {
                if (type === 1)
                    message.info(infoMessages.recommendationPublish)
                else if (type === 2)
                    message.info(infoMessages.recommendationRestrict)
                return;
            }

            const { selectedRecommendation } = this.state;
            console.log("selectedRecommendation", selectedRecommendation)
            const { tenantId, authToken, userId, updateStatusAcceptRejectOptimizerAction, thirdPartyExecuteAction } = this.props;

            let params = { id: selectedRecommendation.id, type: type };

            const response = await updateStatusAcceptRejectOptimizerAction({ tenantId, authToken, userId, params });
            const { responseCode: { status = "", desc } } = response;

            if (status == "Success") {
                if (type == 1) {
                    message.success(desc);
                    let payload = {
                        recoRequest: [selectedRecommendation]
                    }
                    const thirdPartyResponse = await thirdPartyExecuteAction({ tenantId, authToken, userId, payload, params: '' });
                    const { responseCode: { status: thirdPartyExecuteStatus, msg: thirdPartyExecuteMsg } } = thirdPartyResponse;

                    if (isApiCallSuccess(thirdPartyExecuteStatus)) {
                        this.setState({ thirdPartyExecuteMessage: thirdPartyExecuteMsg, acceptModal: true, viewRecommendModal: false });
                    }
                } else if (type == 2) {
                    this.setState({ rejectModal: true, viewRecommendModal: false });
                }
            }

        } catch (error) {
            console.error('Error:', error);
        }
    };

    capitalizeWords(str) {
        if (typeof str !== 'string') {
            return str; // Return the input unchanged if it's not a string
        }
        return str.replace(/\b\w/g, function (char) {
            return char.toUpperCase();
        });
    }

    breakCamelCase(key) {
        return key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, function (str) { return str.toUpperCase(); });
    }


    generateOptions = (sectionTitle, recommendationType) => {
        const advertiserData = JSON.parse(sessionStorage.getItem('advertiserData')) || {};
        const advertiserId = advertiserData.advertiserId || advertiserData.tenantId;
        const isAgency = isTenantAgency(this.props.tenantId);
        const { tenantId } = this.props;
        const targetTimeZone = getTenantTimeZone(tenantId);

        switch (sectionTitle) {
            case 'generativeAI':
                switch (recommendationType) {
                    case 'creatives':
                    case 'keyword':
                        options.columns.forEach((dataCol, index) => {
                            if (dataCol.name == "date") {
                                dataCol["component"] = (row) => row.date ? moment(getDateFromUtcToSpecificZone({ date: row.date, targetTimeZone: targetTimeZone })).format("YYYY-MM-DD") : '-'
                            }
                        })
                        return (advertiserId || isAgency || isPlatformManager()) ? this.addAdvertiserColumnToOptions(options, advertiserId) : options;
                    default:
                        return {}; // Return default options if recommendationType doesn't match
                }
            case 'blackListing':
                const blacklistingTable = this.getBlackListingTable(recommendationType);
                blacklistingTable.columns.forEach((dataCol, index) => {
                    if (dataCol.name == "date") {
                        dataCol["component"] = (row) => row.date ? moment(getDateFromUtcToSpecificZone({ date: row.date, targetTimeZone: targetTimeZone })).format("YYYY-MM-DD") : '-'
                    }
                    // specific for demo accounts
                    if (dataCol.name === 'creativeName' && this.isDemoAdvertiser) {
                        dataCol['component'] = (row) => row.recoValue
                    }
                })
                return (advertiserId || isAgency) ? this.addAdvertiserColumnToOptions(blacklistingTable, advertiserId) : blacklistingTable;
            case 'budgetOptimisation':
                const optimizerTable = this.getOptimizerTable(recommendationType);
                optimizerTable.columns.forEach((dataCol, index) => {
                    if (dataCol.name == "date") {
                        dataCol["component"] = (row) => row.date ? moment(getDateFromUtcToSpecificZone({ date: row.date, targetTimeZone: targetTimeZone })).format("YYYY-MM-DD") : '-'
                    }
                    // specific for demo accounts
                    if (dataCol.name === 'oldBudget' && this.isDemoAdvertiser) {
                        dataCol['component'] = (row) => row.bekiRecoInfoBudget
                    }
                    if (dataCol.name === 'allocatedBudget' && this.isDemoAdvertiser) {
                        dataCol['component'] = (row) => row.bekiRecoValueBudget
                    }
                })
                return (advertiserId || isAgency) ? this.addAdvertiserColumnToOptions(optimizerTable, advertiserId) : optimizerTable;
            case 'bidControl':
                const bidControlTable = this.getBidControlTable(recommendationType);
                bidControlTable.columns.forEach((dataCol, index) => {
                    if (dataCol.name == "date") {
                        dataCol["component"] = (row) => row.date ? moment(getDateFromUtcToSpecificZone({ date: row.date, targetTimeZone: targetTimeZone })).format("YYYY-MM-DD") : '-'
                    }
                })
                return (advertiserId || isAgency) ? this.addAdvertiserColumnToOptions(bidControlTable, advertiserId) : bidControlTable;
            default:
                return {}; // Return default options if sectionTitle doesn't match
        }
    };


    // generateOptions = (sectionTitle, recommendationType) => {
    //     const advertiserData = JSON.parse(sessionStorage.getItem('advertiserData')) || {};
    //     const advertiserId = advertiserData.advertiserId || advertiserData.tenantId;
    //     const isAgency = isTenantAgency(this.props.tenantId);

    //     let options = addColumnsBasedOnSection(sectionTitle, recommendationType);

    //     // Add advertiser column if required
    //     if (advertiserId || isAgency || isPlatformManager()) {
    //       options = this.addAdvertiserColumnToOptions(options, advertiserId);
    //     }

    //     return options;
    //   };


    addAdvertiserColumnToOptions = (options, advertiserId) => {
        // Check if the 'advertiser' column already exists
        const advertiserColumnExists = options.columns.some(col => col.name == 'tenantName');

        // If the 'advertiser' column already exists, return the options as is
        if (advertiserColumnExists) {
            return options;
        }

        // If the 'advertiser' column does not exist, add it to the options
        const optionsWithAdvertiser = { ...options };
        const advertiserColumnId = options.columns.length > 0 ? Math.max(...options.columns.map(col => col.id)) + 1 : 1;
        const advertiserColumn = {
            id: advertiserColumnId,
            name: 'tenantName',
            label: 'ADVERTISER',
            sortable: true,
            type: 'string',
            default: advertiserId,
            component: (row) => <div>{row && row.tenantName ? row.tenantName : '-'}</div>

        };

        // Insert the advertiser column at the second position
        optionsWithAdvertiser.columns.splice(1, 0, advertiserColumn);

        return optionsWithAdvertiser;
    };


    getBlackListingTable = (recommendationType) => {
        switch (recommendationType) {
            case 'creatives':
                return creativeBlacklistingTable;
            case 'domain':
                return domainBlacklistingTable;
            case 'keyword':
                return keyWordBlacklistingTable;
            case 'age':
                return ageBlacklistingTable;
            case 'gender':
                return genderBlacklistingTable;
            case 'placements':
                return placementBlacklistingTable;
            case 'geo':
                return geoBlacklistingTable;
            case 'device':
                return deviceBlacklistingTable;
            default:
                return {}; // Return default options if recommendationType doesn't match
        }
    };

    getOptimizerTable = (recommendationType) => {
        switch (recommendationType) {
            case 'budgetAllocation':
                return budgetAllocationTable;
            case 'targetCpc':
                return targetCpcTable;
            case 'targetCpm':
                return targetCpmTable;
            case 'targetCpa':
                return targetCpaTable;
            case 'targetRoas':
                return targetRoasTable;
            default:
                return {}; // Return default options if recommendationType doesn't match
        }
    };

    getBidControlTable = (recommendationType) => {
        switch (recommendationType) {
            case 'age':
                return ageBidControlTable;
            case 'gender':
                return genderBidControlTable;
            case 'audience':
                return audienceBidControlTable;
            case 'geo':
                return geoBidControlTable;
            case 'device':
                return deviceBidControlTable;
            case 'bid':
                return bidSubtypeBidControlTable;
            default:
                return {}; // Return default options if recommendationType doesn't match
        }
    };



    render() {
        const advertiserData = JSON.parse(sessionStorage.getItem('advertiserData'));
        const advertiserId = advertiserData && advertiserData.advertiserId;

        const { handleTotalSectionClick, handleSubsectionClick } = this.props;
        const { IsAgency, thirdPartyExecuteMessage, acceptModal, rejectModal, viewRecommendModal, selectedRecommendation, keywordRecommendationData, creativeRecommendationData } = this.state;

        // Extracting the section from the pathname
        const { history, history: { location: { pathname = '' } }, location } = this.props;

        const { tenantId } = this.props;
        const targetTimeZone = getTenantTimeZone(tenantId);

        const optimizerTypes = location.state;
        const sections = pathname.split('/');
        console.log('optimizerTypes:', optimizerTypes);

        let section;
        if (optimizerTypes && optimizerTypes.variation == "subType") {
            section = sections[sections.length - 2];
        } else {
            section = sections.pop();
        }
        // Using the section to dynamically access the recommendation data
        const recommendationData = this.state.recommendationData || {};
        const sectionTitle = Object.keys(recommendationData)[0];
        const sectionRecommendationData = recommendationData[sectionTitle];
        // Check if sectionRecommendationData is defined
        // if (sectionRecommendationData) {
        //     // Iterate through the "subtype" arrays
        //     for (const key in sectionRecommendationData) {
        //         // Add the "subType" key to each object with the appropriate value
        //         sectionRecommendationData[key].forEach(obj => {
        //             obj.type = key;
        //         });
        //     }
        // }

        return (
            <>

                {<Modal open={acceptModal} size='tiny'>
                    <div style={{ width: '100%', height: '100%', background: 'white', boxShadow: '0px 20px 70px rgba(0, 0, 0, 0.25)', borderRadius: 10, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', display: 'inline-flex' }}>
                        <i className="ti ti-x" style={{ position: "absolute", right: 5, top: 5, fontSize: 25, cursor: "pointer" }} onClick={() => { this.setState({ acceptModal: false }) }}></i>
                        <div style={{ alignSelf: 'stretch', flex: '1 1 0', borderRadius: 20, flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 10, display: 'flex' }}>
                            <div style={{ alignSelf: 'stretch', flex: '1 1 0', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 10, display: 'flex' }}>
                                <div style={{ alignSelf: 'center', textAlign: '-webkit-center', flex: '1 1 0', padding: "80px 120px", background: 'white', borderRadius: 20, display: "flex", flexDirection: "column", alignItems: "center" }} >
                                    <SuccessCheckMark />
                                    <div className="mt-5" style={{ textAlign: 'center', color: '#394256', fontSize: 24, fontWeight: '500', wordWrap: 'break-word', lineHeight: 1.2 }}>{thirdPartyExecuteMessage}</div>
                                    {/* <div className='mt-4' style={{ width: '100%', textAlign: 'center', color: '#707B8A', fontSize: 16, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word' }}>You have accepted the
                                    recommendation</div> */}
                                    <button className="btn btn-primary mt-3 p-3 px-4" onClick={() => {
                                        this.setState({ acceptModal: false });
                                        window.location.reload();
                                    }} >OK</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal>}

                {<Modal open={rejectModal} size='tiny'>
                    <div style={{ width: '100%', height: '100%', background: 'white', boxShadow: '0px 20px 70px rgba(0, 0, 0, 0.25)', borderRadius: 10, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', display: 'inline-flex' }}>
                        <i className="ti ti-x" style={{ position: "absolute", right: 5, top: 5, fontSize: 25, cursor: "pointer" }} onClick={() => { this.setState({ rejectModal: false }) }}></i>
                        <div style={{ alignSelf: 'stretch', flex: '1 1 0', borderRadius: 20, flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 10, display: 'flex' }}>
                            <div style={{ alignSelf: 'stretch', flex: '1 1 0', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 10, display: 'flex' }}>
                                <div style={{ alignSelf: 'center', textAlign: '-webkit-center', flex: '1 1 0', padding: "80px 120px", background: 'white', borderRadius: 20, display: "flex", flexDirection: "column", alignItems: "center" }} >
                                    <img style={{ width: 80, height: 80 }} src={Reject} />
                                    <div className="mt-5" style={{ textAlign: 'center', color: '#394256', fontSize: 24, fontWeight: '500', wordWrap: 'break-word', lineHeight: 1.2 }}>You have rejected the recommendation</div>
                                    <button className="btn btn-primary mt-3 p-3 px-4" onClick={() => {
                                        this.setState({ rejectModal: false });
                                        window.location.reload();
                                    }} >OK</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal>}


                <Modal open={viewRecommendModal} >
                    <div style={{ width: '100%', height: '100%', background: 'white', boxShadow: '0px 20px 70px rgba(0, 0, 0, 0.25)', borderRadius: 10, flexDirection: 'column', justifyContent: 'flex-start', display: 'inline-flex' }}>
                        <div className='d-flex justify-content-center align-items-center p-3' style={{ background: "#F7F8FC" }}>
                            <h5 className='mb-0' style={{ fontWeight: 500 }}>
                                {selectedRecommendation && selectedRecommendation.type && this.capitalizeWords(selectedRecommendation.type)} Recommendation Details
                            </h5>
                            <i className="ti ti-x" style={{ position: "absolute", right: 5, top: 10, fontSize: 25, cursor: "pointer" }} onClick={() => { this.setState({ viewRecommendModal: false }) }}></i>
                        </div>
                        <div className='row p-3'>
                            {selectedRecommendation && selectedRecommendation != null && typeof selectedRecommendation === 'object' ? (
                                Object.keys(selectedRecommendation).map((key, index) => (
                                    key !== "type" && key !== "id" && key != "subTypeId" && key != "recoInfo" &&
                                    <div className='col-6' key={index}>
                                        <p style={{ color: "#707B8A" }} className='mb-0'><small>{this.breakCamelCase(key)}</small></p>
                                        <h6 style={{ fontWeight: 500, fontSize: 14, lineBreak: 'anywhere' }}>
                                            {selectedRecommendation[key] ?
                                                (key === "date" ?
                                                    moment(getDateFromUtcToSpecificZone({ date: selectedRecommendation[key], targetTimeZone: targetTimeZone })).format('YYYY-MM-DD') :
                                                    (key === "expectedOutcome" ?
                                                        parseFloat(selectedRecommendation[key]).toFixed(2) :
                                                        (this.isValidUrl(selectedRecommendation[key]) ?
                                                            <a href={selectedRecommendation[key]} target="_blank" rel="noopener noreferrer">{selectedRecommendation[key]}</a> :
                                                            this.capitalizeWords(selectedRecommendation[key])
                                                        )
                                                    )
                                                ) : ""
                                            }

                                        </h6>
                                    </div>
                                ))
                            ) : (
                                <Card>
                                    <div className='text-center'>
                                        <h5>No Data Available</h5>
                                    </div>
                                </Card>
                            )}
                            {/* Special handling for recoInfo */}
                            {selectedRecommendation && selectedRecommendation.recoInfo && (
                                <div className='col-12'>
                                    <p style={{ color: "#707B8A" }} className='mb-0'><small>{this.breakCamelCase('recoInfo')}</small></p>
                                    <div style={{ fontWeight: 500, fontSize: 14 }}>
                                        {selectedRecommendation.recoInfo.split(',').map((info, index) => (
                                            this.isValidUrl(info.trim()) ?
                                                <div className="p-1" key={index}><a href={info.trim()} target="_blank" rel="noopener noreferrer">{info.trim()}</a></div> :
                                                <div className="p-1" key={index}>{this.capitalizeWords(info.trim())}</div>
                                        ))}
                                    </div>
                                </div>
                            )}
                            <div className='col-5'></div>
                        </div>
                        <div className='d-flex justify-content-end align-items-center p-3' style={{ background: "#F7F8FC" }}>
                            {checkPermission({ permissions: [PERMISSION.OPTIMIZER.OPTIMIZER.EDIT] }) && (
                                <button className='btn btn-transparent text-danger border border-danger mr-3' onClick={() => { this.handleActionOverRecommedation(2) }}>
                                    <i className='ti ti-x'></i> Reject
                                </button>
                            )}
                            {checkPermission({ permissions: [PERMISSION.OPTIMIZER.OPTIMIZER.EDIT] }) && (
                                <button className='btn btn-success' onClick={() => { this.handleActionOverRecommedation(1) }}>
                                    <i className='ti ti-check'></i> Accept
                                </button>
                            )}
                        </div>
                    </div>
                </Modal>


                <div className="main-panel ion">
                    <div className="content-wrapper">
                        <BreadCrumb />
                        <div className="row mt-3 campaign-adj optimizer-adj">
                            <Card>
                                {IsAgency && advertiserId &&
                                    <div className="d-flex col-md-12 align-items-center justify-content-end position-absolute" style={{ right: 10 }}>
                                        <div className='badge badge-secondary text-dark'>{advertiserData.advertiserName}</div>
                                    </div>
                                }
                                {sectionRecommendationData ? Object.entries(sectionRecommendationData).map(([recommendationType, dataKey], index) => (
                                    <div className={`pb-4 ${index == 0 ? 'mt-n1' : ''}`} key={recommendationType}>
                                        <h5>{(recommendationType.charAt(0).toUpperCase() + recommendationType.slice(1))} Recommendations</h5>
                                        <div className="optimiser-subsection-table campaign-list-adj table-responsive">
                                            <Table
                                                options={checkTablePermission({ edit: PERMISSION.OPTIMIZER.OPTIMIZER.EDIT, view: PERMISSION.OPTIMIZER.OPTIMIZER.VIEW }, this.generateOptions(sectionTitle, recommendationType))}
                                                data={dataKey || []}
                                                handelAction={this.handleRecommedationAction}
                                            />
                                        </div>
                                    </div>
                                ))
                                    :
                                    <div className='text-center'>
                                        <h5>No Data Available</h5>
                                    </div>
                                }
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(connect(
    state => ({
        paymentAccess: get(state, 'app.paymentAccess.response', {}),
        getUserPermissionList: get(state, 'app.getUserPermissionList', []),
        configurationList: get(state, 'app.configurationData.responseList', []),
        ioListAll: get(state, 'app.ioListAllReport.responseList', []),
        tenantId: get(state, 'app.preSignInState.tenantId', ''),
        userId: get(state, 'app.preSignInData.userId', ''),
        authToken: get(state, 'app.signInData.authToken', '')
    }),
    {
        getOptimizerListAction,
        getOptimizerListRecommendationAction,
        getPaymentRelatedAccessAction,
        updateStatusAcceptRejectOptimizerAction,
        thirdPartyExecuteAction,
        getRecoTypeSubTypeAction
    }
)(index));

// ----*  IO propTypes * ----
index.propTypes = {
    configurationList: PropTypes.array,
    tenantId: PropTypes.number,
    userId: PropTypes.number,
    authToken: PropTypes.string,
};